<script>
import { manageStoreMethods } from "@state/helpers";
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    name: 'LabelsModal',
    props: {
        activeStore: {
            type: Object,
            required: false,
            default: () => {}
        },
        activeAccessPoint: {
            type: Object,
            required: false,
            default: () => {}
        },
        references: {
            type: Array,
            required: false,
            default: () => []
        },
        templates: {
            type: Array,
            required: false,
            default: () => []
        },
        callback: {
            type: Function,
            required: false,
            default: () => {}
        },
        closeModal: {
            type: Function,
            required: true
        }
    },
    components: { 
        ValidationProvider, ValidationObserver
    },
    data() {
        return {
            newLabel: {
                id: null,
                location: null,
                reference: null,
                template: '',
            },
            isSubmitting: false,
            isModalVisible: true,
            assignModalShow: false,
            randomId: Math.random()
        }
    },
    methods: {
        ...manageStoreMethods,
        async submitForm() {
            const isValid = await this.$refs.observer.validate();
            const errors = Object.values(this.$refs.observer.errors).flat();
            if (!isValid) {
                this.$generate_noty('warn', this.$t('forms.form_errors', {'errors':errors.length}), this.$t('alerts.error'),  5000, true)
                return
            }
            this.assignModalShow = true;
        },
        saveLabel(){
            let context = this
            this.isSubmitting = true
            const payload = (
                this.newLabel.id &&
                this.newLabel.template
                ) ? {
                    id: this.newLabel.id,
                    store_id: this.activeStore._id,
                    access_point_id: this.activeAccessPoint.id,
                    reference_id: this.newLabel.reference,
                    location_id: this.newLabel.location || '',
                    template: this.newLabel.template
                } : null;
            if (!payload){
                const error = "Verifica los datos"
                this.$generate_noty('error', this.$t('forms.create_error'), error, 3000, true);
                this.cancel_or_error(error)
                
                this.isSubmitting = false
                return
            }
            this.createUpdateLabel((payload)).then(resp => {
                context.isSubmitting = false
                context.callback(resp)
            })
        },
    },
    computed: {
        getReference(){
            return this.newLabel.template.reference || this.newLabel.id ? this.newLabel.id.substring(0, 2) : '';
        },
        getReferences(){
            let _this = this
            let _references = _this.references.filter(x => 
                                    x.fabricant === _this.activeAccessPoint.fabricant
                                ).map(x => ({ value: x.id, text: `${x.id} - Tint: ${x.tint_colors} - Inch: ${x.inches} - Res: ${x.screen_width}x${x.screen_height}` }))
            if (_references.length === 0){
                return { value: null, text: 'No se encontraron' }
            }
            return _references
        },
        getTemplates(){
            let _this = this
            let _templates = this.templates.filter(y => _this.newLabel.reference === y.reference).map(x => ({ value: x.name, text: x.name }))
            if (_templates.length === 0){
                return { value: null, text: 'No se encontraron' }
            }
            return _templates
        }
    },
    watch: {
        newLabel: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                if (!this.newLabel.id || this.newLabel.id === "" || (this.getTemplates.length > 0 && this.getTemplates[0].value === null)){
                    this.newLabel.template = null;
                }
            }
        }
    }
}
</script>



<template>
    <div>
        <b-modal 
            v-model="isModalVisible" size="sm" 
            :title="`Tienda: ${activeStore && activeStore.name || ''} - AP: ${activeAccessPoint && activeAccessPoint.id}`" 
            @hide="closeModal('cancel')"
            @ok="assignModalShow = true"
            hide-footer
            >
            <ValidationObserver ref="observer" @submit.prevent="submitForm">
                <b-form ref="createform" >
                    <b-row>
                        <b-col md="12">
                            <h4>Nueva Etiqueta</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6">
                            ID (MAC):
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="id"
                                :rules="{'required': true, 'regex': `^[a-zA-Z0-9:]{8}([a-zA-Z0-9:]{4})?$` }">
                                <b-form-input v-model="newLabel.id" type="text" name="id" placeholder="ID (MAC)" />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            Ubicación:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="location"
                                :rules="{'required': true, 'min': 2 }">
                                <b-form-input v-model="newLabel.location" type="text" name="location" placeholder="Ubicación"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4" v-if="newLabel.id && newLabel.id.length >= 8">
                            {{ $t('fields.reference')}}:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="template"
                                :rules="{'required': true }">
                                <b-form-select v-model="newLabel.reference" :options="getReferences" name="template"  />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4" v-if="newLabel.reference">
                            {{ $t('labels.deviceVariables.template') }}:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="template"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-select v-model="newLabel.template" :options="getTemplates" name="template"  />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-card-footer class="bg-transparent p-0 mt-3">
                        <b-button size="sm" variant="secondary" @click="closeModal">
                            {{ $t("basic.cancel") }}
                        </b-button>
                        <b-button type="submit" size="sm" variant="primary" :disabled="isSubmitting" class="ml-1">
                            <span v-if="!isSubmitting">
                                {{ $t("basic.add") }}
                            </span>
                            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
                        </b-button>
                    </b-card-footer>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal
            id="assign-modal"
            v-model="assignModalShow"
            :title="$t('basic.add')"
            :ok-title="$t('basic.add')"
            ok-variant="primary"
            @hidden="() => assignModalShow = false"
            @ok="saveLabel"
            >
            <p v-if="newLabel">
                <b>Está seguro de agregar esta nueva Etiqueta?</b>
                <br>
                <br>
                ID (Mac): <b>{{  newLabel.id }}</b><br>
                Ubicación: <b>{{  newLabel.location }}</b><br>
                Referencia: <b>{{  newLabel.reference }}</b><br>
                Plantilla: <b> {{ newLabel.template }}</b><br>
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                    <span v-if="!isSubmitting">
                        {{ $t("basic.accept") }}
                    </span>
                    <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                    </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>